import React from 'react';
import * as Styles from './styles';

interface IProps {
    text?: string;
}

const HorizontalDivider: React.FC<IProps> = (props: IProps) => {
    const { text } = props;

    return (
        <Styles.DividerWrapper>
            <Styles.Line />
            {text && <Styles.Text>{text}</Styles.Text>}
            <Styles.Line />
        </Styles.DividerWrapper>
    );
};

export default HorizontalDivider;
